import constants from '@/libs/constant/constants'
import {cloneDeep, sortBy, isEmpty, filter, find} from 'lodash'
import {message, loader, urlValidation, navigateTo, getImageUrl, onError, errorHandler, logout, beforeAvatarUpload} from '@/libs/helper'
import {
    updateAuthor,
    getLanguages,
    uniqueListing,
    updatePublisher,
    updatePublication,
    uploadImage,
    getImageUploadURL,
    createPublisher,
    validateScreenName,
    addAdminPublisher,
    addPublicationToOrganisation
} from '@/libs/api/api'
import locationFormMixin from '@/mixins/locationFormMixin';
import countryCode from '@/libs/constant/countrycode'

export default {
    name: 'MaintainAuthor',
    mixins: [locationFormMixin],
    props: {
        stepBack: {
            type: Function,
            default: ()=>{}
        },
        stepForward: {
            type: Function,
            default: ()=>{}
        },
        setClaimTo: {
            type: Function,
            default: ()=>{}
        },
        cancel: {
            type: Function,
            default: ()=>{}
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        isEdit: {
            type: Boolean,
            default: () => false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        isAdd: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        organisationDetails: {
            type: Object,
            default: () => {}
        }
    },
    beforeMount() {
        if(this.module === constants.PUBLICATION.key){
            getLanguages()
                .then((response)=>{
                    this.languages = sortBy(cloneDeep(response.languages), 'name') || []
                })
                .catch(()=>{})
        }
        this.imageAvatar = this.claimTo.avatar_image || null
        this.imagePreview = this.claimTo.imagePreview || null
        if (this.claimTo && this.claimTo.address && this.claimTo.address.country_code) {
            this.address.country_name = this.getCountryName()
        } else {
            this.address.country_name = 'Netherlands'
        }
    },
    components: {
        ManageAuthorName: () => import(/* webpackChunkName: "author" */ '../ManageAuthorName/ManageAuthorName.vue'),
        ManageAuthorDescription: () => import(/* webpackChunkName: "author" */ '../ManageAuthorDescription/ManageAuthorDescription.vue'),
        ManageAuthorImage: () => import(/* webpackChunkName: "author" */ '../ManageAuthorImage/ManageAuthorImage.vue'),
    },
    watch:{
        claimTo: function(newValue){
            this.card = {
                first_name: newValue.first_name || '',
                middle_name: newValue.middle_name || '',
                last_name: newValue.last_name || '',
                website: newValue.url && newValue.url.length > 0 ? newValue.url[0] : newValue.website && newValue.website.length > 0 ? newValue.website[0] : '',
                screen_name: newValue.screen_name || ''
            }

            this.publisher = {
                name: newValue.name || '',
                website: newValue.url && newValue.url.length > 0 ? newValue.url[0] : newValue.website && newValue.website.length > 0 ? newValue.website[0] : '',
                registration_number: newValue.registration_number || '',
                screen_name: newValue.screen_name || ''
            }

            this.publication = {
                name: newValue.name || '',
                language: (newValue.language) || {},
                language_name: ((newValue.language_name) || (newValue.language && newValue.language.language_name)) || '',
                screen_name: newValue.screen_name || ''
            }
        }
    },
    data() {
        return {
            isEmpty,
            navigateTo,
            getImageUrl,
            onError,
            beforeAvatarUpload,
            languages: [],
            selectedLanguage: {},
            copyRight: {
                copy_right: this.claimTo.copy_right || ''
            },
            card: {
                first_name: this.claimTo.first_name || '',
                middle_name: this.claimTo.middle_name || '',
                last_name: this.claimTo.last_name || '',
                website: this.claimTo.url && this.claimTo.url.length > 0 ? this.claimTo.url[0] : this.claimTo.website && this.claimTo.website.length > 0 ? this.claimTo.website[0] : '',
                screen_name: this.claimTo.screen_name || ''
            },

            publisher: {
                name: this.claimTo.name || '',
                website: this.claimTo.url && this.claimTo.url.length > 0 ? this.claimTo.url[0] : this.claimTo.website && this.claimTo.website.length > 0 ? this.claimTo.website[0] : '',
                registration_number: this.claimTo.registration_number || '',
                screen_name: this.claimTo.screen_name || ''
            },

            publication: {
                name: this.claimTo.name || '',
                language: (this.claimTo.language) || {},
                screen_name: this.claimTo.screen_name || '',
                language_name: ((this.claimTo.language_name) || (this.claimTo.language && this.claimTo.language.language_name)) || ''
            },
            des: {
                biography: this.claimTo.biography || '',
                short_description: this.claimTo.short_description || '',
                managing_editor: this.claimTo.managing_editor || ''
            },
            address: {
                line1:  this.claimTo && this.claimTo.address && this.claimTo.address.line1 || '',
                line2:  this.claimTo && this.claimTo.address && this.claimTo.address.line2 || '',
                postal_code: this.claimTo && this.claimTo.address && this.claimTo.address.postal_code || '',
                city: this.claimTo && this.claimTo.address && this.claimTo.address.city || '',
                country_code: this.claimTo && this.claimTo.address && this.claimTo.address.country_code || 'NL',
                country_name: ''
            },
            contact_detail: {
                phone: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.phone || '',
                fax: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.fax || '',
                email: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.email || ''
            },
            webSiteValidation: function (rule, value, callback) {
                if (isEmpty(value)) callback(new Error(window.i18next.t('Field should not be empty'))) 
                if (value && value !== '' && (value.includes('http://') || value.includes('https://'))) callback(new Error(window.i18next.t('Try adding url without web protocols(http or https)')))
                if (!urlValidation('https://' + value)) callback(new Error(window.i18next.t('Incorrect url'))) 
                else callback()
            },
            nameLimitValidation: function (rule, value, callback) {
                if(rule.field === 'middle_name' && value.split('').length === 0 ){
                    callback();
                } else if(value.split('').length < 2){
                    callback(new Error(window.i18next.t('Minimum 2 character required')));
                } else{
                    callback();
                }
            },
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                else callback()
            },
            adminWebsiteValidation: function (rule, value, callback) {
                if (!isEmpty(value) && value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
                if (!isEmpty(value) && !urlValidation('https://' + value)) callback(new Error('Incorrect url'))
                else callback() 
            },
            imageAvatar: this.claimTo.avatar_image || null,
            imageBlobData: this.claimTo && this.claimTo.imageBlobData || null,
            imagePreview: this.claimTo && this.claimTo.imagePreview || null,
            imageName: this.claimTo && this.claimTo.imageName || '',
            uploadImageData:{},
            file: {},
            validatePostalCode: this.validatePostalCodeFunction
        }
    },
    methods: {
        getLabel (module) {
            switch (module){
                case constants.AUTHOR.key:
                    return 'Basic Author Settings'
                case constants.PUBLISHER.key:
                    return 'Basic Publisher Settings'
                case constants.PUBLICATION.key:
                    return 'Basic Publication Settings'
            }
        },
        /**
         * to save the form and validate
         * @param {*} module type
         * @param {*} isBack when back button is pressed
         */
        submit (module) {
            switch (module) {
                case constants.AUTHOR.key:
                    this.saveAndCheckAuthor()
                break
                case constants.PUBLISHER.key:
                    this.saveAndCheckPublisher()
                break
                case constants.PUBLICATION.key:
                    this.saveAndCheckPublication()
                break
            }
            
        },
        saveAndCheck () {
            let isValid = true
            let formNames = ['manageAuthorDescription', 'manageAuthorLocation', 'manageAuthorImage']
            if (this.module === constants.AUTHOR.key) formNames.push('manageAuthorName')
            else if (this.module === constants.PUBLISHER.key) formNames.push('managePublisherName')
            formNames.map(formName => {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isValid = false
                    }
                })
            })
            if (!isValid) return
            this.stepForward()
        },
        getHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Basic Author settings'
                case constants.PUBLISHER.key:
                    return 'Basic Publisher settings'
                case constants.PUBLICATION.key:
                    return 'Basic Publication settings'
                case 'USER': 
                    return 'User Name'   
            }
        },
        getSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Basic settings of this Author. These settings will be used to create the profile of the Author in the Information Portal'
                case constants.PUBLISHER.key:
                    return 'Basic Settings of this Publisher. These settings will be used to create the profile of this publisher in the Information Portal'
                case constants.PUBLICATION.key:
                    return 'Basic Settings of this Publication. These settings will be used to create the profile of this publication in the Information Portal'
                case 'USER': 
                    return 'Basic Settings of this User. These settings will be used to create the profile of this User in the Information Portal'
            }
        },
        getDescriptionSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Give a short description and biography of the Author in the fields below'
                case constants.PUBLISHER.key:
                    return 'Give a short description and biography of the Publisher in the fields below'
                case constants.PUBLICATION.key:
                    return 'Give a short description and biography of the Publication in the fields below'
            }
        },
        getLocationHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Location'
                case constants.PUBLISHER.key:
                    return 'Publisher Location'
                case constants.PUBLICATION.key:
                    return 'Publication Location'
                case 'USER':
                    return 'User Location'    
            }
        },
        getLocationSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Please provide the main location of the Author'
                case constants.PUBLISHER.key:
                    return 'Please provide the main location of the Publisher'
                case constants.PUBLICATION.key:
                    return 'Please provide the main location of the Publication'
                case 'USER':
                    return 'User Address'    
            }
        },
        saveCopyRights (formName) {
            let isValid = false
            let claimTo = this.claimTo
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if (valid) {
                    claimTo.copy_right = this.copyRight.copy_right 
                }
                
            })
            return isValid
        },
        saveEditRights (formName) {
            let isValid = false
            let claimTo = this.claimTo
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if (valid) {
                    claimTo.managing_editor = this.des.managing_editor
                }
            })
            return isValid
        },
        submitImageForm (formName) {
            let claimTo = this.claimTo
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if(valid){
                    claimTo.avatar_image = this.imageAvatar
                    claimTo.imagePreview = this.imagePreview
                    claimTo.imageName = this.imageName
                    claimTo.imageBlobData = this.imageBlobData
                }
            })
            return isValid
        },
        /**
         *  save and validate desc form
         */
        submitDescriptionForm (formName) {
            let claimTo = this.claimTo
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if(valid){
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
                }
            })
            return isValid
        },
        /**
         * save and validate location form
         * @param {*} module 
         * @param {*} formName 
         */
        submitLocationForm (module, formName) {
            let claimTo = this.claimTo
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if(valid){
                    claimTo.address = this.address
                    if (module === constants.PUBLISHER.key) {
                        claimTo.contact_detail = this.contact_detail
                    }
                }
            })
            return isValid
        },
        submitNameForm (module) {
            switch (module){
                case constants.AUTHOR.key:
                    this.submitAuthorForm('manageAuthorName')
                    break
                case constants.PUBLISHER.key:
                    this.submitPublisherForm('managePublisherName')
                    break
                case constants.PUBLICATION.key:
                    this.submitPublicationForm('managePublicationName')
                    break
            }
        },
        submitAuthorForm (formName) {
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if(valid){

                    loader(this, true)
                    
                    let body = {
                        url: `https://${this.card.website}`,
                        first_name: this.card.first_name,
                        last_name: this.card.last_name,
                        type: this.module
                    }
                    
                    if(this.claimTo._id){
                        body.id = this.claimTo._id
                    }

                    if(this.card.middle_name !== ''){
                        body.middle_name = this.card.middle_name
                    }

                    uniqueListing(body).then((response)=>{
                        loader(this, false)
                        if(response.is_unique){
                            let claimTo = this.claimTo
                            claimTo.first_name = this.card.first_name
                            claimTo.middle_name = this.card.middle_name
                            claimTo.last_name = this.card.last_name
                            let name = this.card.first_name
                            if (this.card.middle_name !== '') {
                                name = `${name} ${this.card.middle_name}`
                            }
                            name = `${name} ${this.card.last_name}`
                            claimTo.name = name
                            claimTo.website = [this.card.website]
                        } else {
                            message(this, constants.messageType.ERROR, ('This set is already available'))
                        }
                    }).catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                }
            })
            return isValid
        },
        submitPublisherForm(formName){
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                // check for admin
                if (valid && !this.isAdmin) {

                    loader(this, true)

                    let body = {
                        url: `https://${this.publisher.website}`,
                        name: this.publisher.name,
                        type: this.module
                    }

                    if(this.claimTo._id){
                        body.id = this.claimTo._id
                    }

                    uniqueListing(body).then((response)=>{
                        loader(this, false)
                        if(response.is_unique){
                            let claimTo = this.claimTo
                            claimTo.name = this.publisher.name
                            claimTo.url = [this.publisher.website]
                            claimTo.website = [this.publisher.website]
                            claimTo.registration_number = this.publisher.registration_number
                        } else {
                            message(this, constants.messageType.ERROR, ('This set is already available'))
                        }
                    }).catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                }
                // admin save fields
                if (this.isAdmin) {
                    let claimTo = this.claimTo
                    claimTo.name = this.publisher.name
                    claimTo.url = [this.publisher.website]
                    claimTo.website = [this.publisher.website]
                    claimTo.registration_number = this.publisher.registration_number
                }
            })
            return isValid
        },
        submitPublicationForm(formName){
            let isValid = false
            this.$refs[formName].validate((valid) => {
                isValid = valid
                if (valid) {
                    let claimTo = this.claimTo
                    claimTo.name = this.publication.name
                    claimTo.language = this.publication.language
                    claimTo.language_name = this.publication.language_name
                }
            })
            return isValid
        },
        handleInputConfirm (item) {
            this.address.country_code = item.country_code || ''
            this.address.country_name = item.country_name || ''
            this.states = [];
            this.searchState = ''
            this.selectedState = {}
            this.fetchStateList(item)
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) return 
            let results = []
            if (!isEmpty(this.countries)) {
                 results = await filter(this.countries, (c) => {
                   return c.country_name.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        getCountryName () {
            let result = ''
            if (this.address && this.address.country_code) {
                filter(this.countries, (country) => {
                    if (country.country_code === this.address.country_code) {
                        result = country.country_name;
                        // fetch state list initially
                        this.fetchStateList(country)
                    }
                })
            }
            return result
        },
        /*
        * selectImageToUpload selects the image on the cropping window.
        * */
       selectImageToUpload (e, num) {
        let file = e.target.files[0]
        this.imageName = e.target.files[0].name
        let reader = new FileReader()
        reader.onload = (e) => {
            let data
            if (typeof e.target.result === 'object') {
                data = window.URL.createObjectURL(new Blob([e.target.result]))
            } else {
                data = e.target.result
            }
            if (num === 1) {
                this.imageCropperConfig.img = data
            }
            this.visibleCropDialog =  !this.visibleCropDialog;
        }
        reader.readAsArrayBuffer(file)
    },
    setImage: async function(){
        this.$refs.imageCropper.getCropData((datafile) => {
            this.imageAvatar = null
            this.imagePreview = datafile
        })
        this.visibleCropDialog =  !this.visibleCropDialog;

        this.imageBlobData = await this.createBlobObject()
    },
        /*
        * createBlobObject() creates and returns the binary image format to upload
        * */
        createBlobObject(uploadUrl, file){
            return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
        },
        getPhotoLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Photo'
                case constants.PUBLISHER.key:
                    return 'Publisher Logo'
                case constants.PUBLICATION.key:
                    return 'Publication Logo'
                case 'ADMIN':
                    return 'User Photo'
            }
        },
        getPhotoDescriptionLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Select the photo of the Author (png, jpeg)'
                case constants.PUBLISHER.key:
                    return 'Select the official logo of the Publisher (png, jpeg)'
                case constants.PUBLICATION.key:
                    return 'Select the official logo of the Publication (png, jpeg)'
                case 'ADMIN': 
                    return 'Select the official logo of the Publication (png, jpeg)'
            }
        },
        getUploadPhotoButtonLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Upload photo'
                case constants.PUBLISHER.key:
                    return 'Upload Logo'
                case constants.PUBLICATION.key:
                    return 'Upload Logo'
                case 'ADMIN':
                    return 'Upload Logo'    
            }
        },
        handleAvatarSuccess () {
        },
        uploadFile:async function (file) {
            this.imageName = file.file.name
            this.file = file
            this.imageBlobData = await this.createBlobObject({}, file.file)
            this.imagePreview = window.URL.createObjectURL(file.file)
            let claimTo = this.claimTo
            claimTo.avatar_image = this.imageAvatar
            claimTo.imagePreview = this.imagePreview
            claimTo.imageName = this.imageName
            claimTo.imageBlobData = this.imageBlobData   
        },
        submitManageForm(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.uploadImageAuthorFlow()
                    break
                case constants.PUBLISHER.key:
                    this.uploadImagePublisherFlow()
                    break
                case constants.PUBLICATION.key:
                    this.uploadImagePublicationFlow()
                    break
            }
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
       uploadImageAuthorFlow(){
        loader(this, true);

        if(this.claimTo.imageBlobData === null){
            this.confirmAuthorFlow()
        }else{
            getImageUploadURL({imageName: this.claimTo.imageName})
                .then((uploadUrl)=>{
                    this.uploadImageData = uploadUrl;
                    return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                }).then(()=>{
                this.confirmAuthorFlow(this.uploadImageData.fileKey)
            }).catch((error)=> {
                loader(this, false);
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
        }
    },
    /*
    * uploadImage() uploads the image to the s3 server
    * */
    uploadImagePublisherFlow(){
        loader(this, true);

        if(this.claimTo.imageBlobData === null){
            if (this.isAdmin) {
                this.confirmAdminPublisher()
            } else {
                this.confirmPublisherFlow()
            }
        }else{
            getImageUploadURL({imageName: this.claimTo.imageName})
                .then((uploadUrl)=>{
                    this.uploadImageData = uploadUrl;
                    return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                }).then(()=>{
                    if (this.isAdmin) {
                        this.confirmAdminPublisher(this.uploadImageData.fileKey)
                    } else {
                        this.confirmPublisherFlow(this.uploadImageData.fileKey)
                    }
            }).catch((error)=> {
                loader(this, false);
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
        }
    },
    /*
    * uploadImage() uploads the image to the s3 server
    * */
    uploadImagePublicationFlow(){
        loader(this, true);

        if(this.claimTo.imageBlobData === null){
            this.confirmPublicationFlow()
        }else{
            getImageUploadURL({imageName: this.claimTo.imageName})
                .then((uploadUrl)=>{
                    this.uploadImageData = uploadUrl;
                    return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                }).then(()=>{
                this.confirmPublicationFlow(this.uploadImageData.fileKey)
            }).catch((error)=> {
                loader(this, false);
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
        }
        },
        confirmAuthorFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.updatedAt;
            delete requestObject.previous_url
            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            requestObject.url = `https://${this.claimTo.url || this.claimTo.website}`
            if (requestObject.social_media) requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            updateAuthor(body, this.claimTo._id)
                .then(()=>{
                    loader(this, false)
                    this.$store.dispatch('updateRegisteredAuthor', cloneDeep(this.claimTo))
                    this.stepForward()
                }).catch((error)=>{
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
            })
        },
        confirmPublisherFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.file
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.authors;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;
            delete requestObject.article_count;

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            requestObject.url = `https://${this.claimTo.url[0]}` || `https://${this.claimTo.website[0]}`

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image
            
            if (requestObject.social_media) requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            if(this.claimTo.isNew){
                createPublisher(body)
                    .then((response)=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublisher', cloneDeep(response.result))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }else{
                updatePublisher(body, this.claimTo._id)
                    .then(()=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublisher', cloneDeep(this.claimTo))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }
        },
        confirmPublicationFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.publisher;
            delete requestObject.authors;
            delete requestObject.updatedAt;
            delete requestObject.language_name
            delete requestObject.domain
            delete requestObject.previous_url

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;
            delete requestObject.scrapped_name;

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            let urls = []
            if (this.claimTo.url && !isEmpty(this.claimTo.url)) {
                urls = this.claimTo.url.map(url => {
                    if (url.includes('https://')) {
                        url = `https://${url}`
                    }
                    return url
                })
            }
            requestObject.url = urls

            if (requestObject.social_media) requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            updatePublication(body, this.claimTo._id)
                .then(()=>{
                    loader(this, false)
                    this.$store.dispatch('updateRegisteredPublication', cloneDeep(this.claimTo))
                    this.stepForward()
                }).catch((error)=>{
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
            })
        },
        /**
         * on next button on edit mode to save 
         * and validate all the forms for author
         */
        saveAndCheckAuthor:async function () {
            let claimTo = this.claimTo
            claimTo.screen_name = this.card.screen_name
            let isValid = await this.submitAuthorForm('manageAuthorName')
            isValid = await this.validateMetaScreenName()
            if (!this.submitImageForm('manageAuthorImage')) isValid = false
            if (!this.submitDescriptionForm('manageAuthorDescription')) isValid = false
            if (!this.submitLocationForm(this.module, 'manageAuthorLocation')) isValid = false
            if (isValid) this.stepForward()
        },

        /**
         * on next button on edit mode to save 
         * and validate all the forms for publisher
         */
        saveAndCheckPublisher: async function() {
            let claimTo = this.claimTo
            claimTo.screen_name = this.publisher.screen_name
            let isValid = await this.submitPublisherForm('managePublisherName')
            let isScreeNameValid = await this.validateMetaScreenName()
            if (!isScreeNameValid) isValid = false
            if (!this.submitImageForm('manageAuthorImage')) isValid = false
            if (!this.submitDescriptionForm('manageAuthorDescription')) isValid = false
            if (!this.submitLocationForm(this.module, 'manageAuthorLocation')) isValid = false
            if (isValid) this.stepForward()
        },

        /**
         * on next button on edit mode to save 
         * and validate all the forms for publication
         */
        saveAndCheckPublication: async function() {
            let claimTo = this.claimTo
            claimTo.screen_name = this.publication.screen_name
            let isValid = await this.validateMetaScreenName()
            if (!this.submitPublicationForm('managePublicationName')) isValid = false
            if (!this.submitImageForm('manageAuthorImage')) isValid = false
            if (!this.submitDescriptionForm('manageAuthorDescription')) isValid = false
            if (!this.submitLocationForm(this.module, 'manageAuthorLocation')) isValid = false
            if (!this.saveEditRights('managePublicationEditor')) isValid = false
            if (!this.saveCopyRights('managePublicationCopyrights')) isValid = false
            if (isValid) this.stepForward()
        },

        /**
         * to validate screen name of 
         * A/P/P on click of next button
         */
        validateMetaScreenName: async function () {
            try {
                // body for api call
                let body = {
                    entity_type: this.module,
                    screen_name: this.module === constants.PUBLISHER.key ? this.publisher.screen_name : this.module === constants.PUBLICATION.key ? this.publication.screen_name : this.card.screen_name
                }
                // api call
                let response = await validateScreenName(body)
                return response.isUnique  
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        /**
         * to change the language
         * @param {*} language 
         */
        changeLanguage (language) {
            const languageResult = {
                ...language, 
                language_id: language._id, 
                operation: 'ADD'
            }
            delete languageResult._id
            this.publication.language = languageResult
            this.publication.language_name = language.display_name
            this.selectedLanguage = language
        },
        /**
         * to get the languages
         */
        queryLanguageSearch (query, cb) {
            if (query !== '' && query !== null && query.length > 1 ) {
                let results = []
                let languages = cloneDeep(this.languages)
                if (!isEmpty(languages)) {
                   results = filter(languages, (language) => {
                        return language.display_name.toLowerCase().includes(query.toLowerCase())
                    })
                }
                cb(results)
            }
        },

        /**
         * save the fields on back button
         */
        saveOnBackButton (module) {
            let claimTo = this.claimTo
            // common fields to sae
            claimTo.avatar_image = this.imageAvatar
            claimTo.imagePreview = this.imagePreview
            claimTo.imageName = this.imageName
            claimTo.imageBlobData = this.imageBlobData
            claimTo.biography = this.des.biography
            claimTo.short_description = this.des.short_description
            claimTo.address = this.address
            // fields only for publisher
            if (module === constants.PUBLISHER.key) {
                claimTo.contact_detail = this.contact_detail
                claimTo.name = this.publisher.name
                claimTo.url = [this.publisher.website]
                claimTo.website = [this.publisher.website]
                claimTo.registration_number = this.publisher.registration_number
            }
            // publications fields
            else if (module === constants.PUBLICATION.key) {
                claimTo.name = this.publication.name
                claimTo.language = this.publication.language
                claimTo.language_name = this.publication.language_name
                claimTo.copy_right = this.copyRight.copy_right
                claimTo.managing_editor = this.des.managing_editor
            }
            // author fields
            else if (module === constants.AUTHOR.key) {
                claimTo.first_name = this.card.first_name
                claimTo.middle_name = this.card.middle_name
                claimTo.last_name = this.card.last_name
                let name = this.card.first_name
                if (this.card.middle_name !== '') {
                    name = `${name} ${this.card.middle_name}`
                }
                name = `${name} ${this.card.last_name}`
                claimTo.name = name
                claimTo.website = [this.card.website]
            }
            // step back method
            this.stepBack()
        },

        /**
         * confirm admin flow of publisher
         */
        confirmAdminPublisher (avatar_image) {
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.file
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.authors;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;
            if (!isEmpty(avatar_image)) {
                requestObject.avatar_image = avatar_image
            }
            if ((this.claimTo.url && this.claimTo.url[0] && this.claimTo.url[0] !== '') || (this.claimTo.website && this.claimTo.website[0] && this.claimTo.website[0] !== '')) {
                requestObject.url = `https://${this.claimTo.url[0] || this.claimTo.website[0]}`
            } else delete requestObject.url

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image
            
            if (requestObject.social_media) {
                requestObject.social_media.map((sm, index)=>{
                    delete requestObject.social_media[index]._id
                })
            }

            let body = requestObject

            if(this.claimTo.isNew){
                addAdminPublisher(body).then(() => {
                    loader(this, false)
                    this.stepForward()
                }).catch((error)=>{
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
                })
            }
        },
        /**
         * validate postal code
         * @param {*} rule 
         * @param {*} value 
         * @param {*} callback 
         */
         validatePostalCodeFunction (rule, value, callback) {
             let regex = ''
             if (this.address.country_code && this.address.country_code !== '') {
                 // find the address code and regex
                 const code = find(countryCode, {abbrev: this.address.country_code})
                 regex = (code && code.postal) || ''
            }
            // validate postal code on basis of regex
            if (regex !== '' && value && value !== '' && !new RegExp(regex).test(value)) callback(new Error('Invalid Postal code'))
            else callback()
        },
        savePublicationToOrg() {
            let body = {
                organisation_id: this.organisationDetails._id,
                publication_id: this.claimTo._id
            }
            addPublicationToOrganisation(body).then(() => {
                this.stepForward()
            }).catch(err => {console.log(err)})
        }
    }
}
